module.exports = __webpack_public_path__ + "static/img/anonymity.3f9b695.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/productDetail/img/anonymity.png
// module id = 7O3t
// module chunks = 0